import { useCallback, useMemo, useReducer } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import emptyFunction from 'react-utils/emptyFunction';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const modalReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        isOpen: true,
        onConfirm: action.onConfirm,
        onCancel: action.onCancel
      };
    case 'CLOSE_MODAL':
      return {
        isOpen: false,
        onConfirm: emptyFunction,
        onCancel: emptyFunction
      };
    default:
      return state;
  }
};
const initialState = {
  isOpen: false,
  onConfirm: emptyFunction,
  onCancel: emptyFunction
};
const StageValidationModal = ({
  onConfirm,
  onCancel
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 450,
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.stageValidation.modals.restartApproval.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.stageValidation.modals.restartApproval.body"
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "danger",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.stageValidation.modals.restartApproval.footer.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.stageValidation.modals.restartApproval.footer.cancel"
        })
      })]
    })]
  });
};
export const useStageValidationModal = () => {
  const [modalState, dispatch] = useReducer(modalReducer, initialState);
  const openModal = useCallback(modalData => {
    dispatch(Object.assign({
      type: 'OPEN_MODAL'
    }, modalData));
  }, [dispatch]);
  const closeModal = useCallback(() => {
    dispatch({
      type: 'CLOSE_MODAL'
    });
  }, [dispatch]);
  const stageValidationModal = useMemo(() => {
    return modalState.isOpen ? /*#__PURE__*/_jsx(StageValidationModal, {
      onConfirm: modalState.onConfirm,
      onCancel: modalState.onCancel
    }) : null;
  }, [modalState]);
  return useMemo(() => ({
    openModal,
    closeModal,
    stageValidationModal
  }), [openModal, closeModal, stageValidationModal]);
};